import { inject } from '@angular/core';
import { Location, LocationStrategy } from '@angular/common';
import { replaceAll } from '../../shared/util/util';

export function initDottnet(): void {
  const location = inject(Location);
  const locationStrategy = inject(LocationStrategy);

  let path = location.path(true); // includes fragment
  path = replaceAll(path, '(', '%28');
  path = replaceAll(path, ')', '%29');

  if (path !== location.path(true)) {
    locationStrategy.replaceState({}, '', path, locationStrategy.getBaseHref());
  }
}


/*import {replaceAll} from '../../shared/util/util';

export function initDottnet(
): void {

  const currentUrl: URL = new URL(window.location.href);
  // clean dirty chars from url
  let pathName: string = replaceAll(currentUrl.pathname, '(', '%28');
  pathName = replaceAll(pathName, ')', '%29');
  if (pathName !== currentUrl.pathname) {
    currentUrl.pathname = pathName;
    history.pushState({}, '', currentUrl.href);
  }

}
*/